import { useState, useEffect, useCallback } from 'react';
import { Flag, Camera } from 'lucide-react';
import { Carousel, CarouselContent, CarouselItem } from '@/components/ui/carousel';

const EXAMPLE_IMAGES = [
  { src: '/kart-base.webp', alt: 'Exemplo de foto gerada com IA no kart' },
  { src: '/kart-example-2.webp', alt: 'Exemplo 2 de foto gerada com IA no kart' },
  { src: '/kart-example-3.webp', alt: 'Exemplo 3 de foto gerada com IA no kart' },
];

export default function Landing({ onQuizStart, onPhotoStart }) {
  const [carouselApi, setCarouselApi] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);

  const onSelect = useCallback(() => {
    if (!carouselApi) return;
    setCurrentSlide(carouselApi.selectedScrollSnap());
  }, [carouselApi]);

  useEffect(() => {
    if (!carouselApi) return;
    onSelect();
    carouselApi.on('select', onSelect);

    const interval = setInterval(() => {
      if (carouselApi.canScrollNext()) {
        carouselApi.scrollNext();
      } else {
        carouselApi.scrollTo(0);
      }
    }, 3000);

    return () => {
      carouselApi.off('select', onSelect);
      clearInterval(interval);
    };
  }, [carouselApi, onSelect]);
  return (
    <div className="animate-fade-in" data-testid="landing-page">
      {/* Option Cards */}
      <section className="px-6 pt-4 space-y-4 mb-8 stagger-children">
        {/* Quiz Card */}
        <button
          className="card-c21 w-full text-left animate-fade-in-up cursor-pointer"
          style={{ opacity: 0 }}
          onClick={onQuizStart}
          data-testid="quiz-card"
        >
          <div className="flex items-start gap-4">
            <div
              className="flex-shrink-0 w-11 h-11 rounded-lg flex items-center justify-center"
              style={{ background: 'rgba(181,152,90,0.12)' }}
            >
              <Flag size={22} strokeWidth={1.5} style={{ color: '#B5985A' }} />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="font-subtitle text-base mb-1 text-white">
                Quiz Velocidade & Imobiliário
              </h3>
              <p className="font-body text-sm" style={{ color: '#A3A3A3' }}>
                Responda e habilite-se ao sorteio trimestral de uma volta de kart!
              </p>
            </div>
          </div>
          <div className="mt-4">
            <span className="btn-gold text-sm py-3" data-testid="quiz-start-btn">
              Jogar Agora
            </span>
          </div>
        </button>

        {/* Photo Card */}
        <button
          className="card-c21 w-full text-left animate-fade-in-up cursor-pointer"
          style={{ opacity: 0 }}
          onClick={onPhotoStart}
          data-testid="photo-card"
        >
          <div className="flex items-start gap-4">
            <div
              className="flex-shrink-0 w-11 h-11 rounded-lg flex items-center justify-center"
              style={{ background: 'rgba(181,152,90,0.12)' }}
            >
              <Camera size={22} strokeWidth={1.5} style={{ color: '#B5985A' }} />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="font-subtitle text-base mb-1 text-white">
                A sua foto no kart com IA
              </h3>
              <p className="font-body text-sm" style={{ color: '#A3A3A3' }}>
                Tire 3 fotos e veja-se num kart de competição
              </p>
            </div>
          </div>

          {/* Example Result Carousel */}
          <div
            className="mt-4 rounded-lg overflow-hidden"
            style={{
              border: '1px solid rgba(181,152,90,0.2)',
              boxShadow: '0 2px 12px rgba(0,0,0,0.3)',
            }}
          >
            <Carousel opts={{ loop: true }} setApi={setCarouselApi}>
              <CarouselContent>
                {EXAMPLE_IMAGES.map((img, i) => (
                  <CarouselItem key={i}>
                    <img
                      src={img.src}
                      alt={img.alt}
                      className="w-full"
                      data-testid={`photo-example-image-${i}`}
                    />
                  </CarouselItem>
                ))}
              </CarouselContent>
            </Carousel>
            <div
              className="font-body text-center py-2 flex items-center justify-center gap-1.5"
              style={{ fontSize: '0.7rem', color: '#A3A3A3', background: '#1A1A1A' }}
            >
              <span>Exemplo de resultado gerado com IA</span>
              <span className="flex gap-1 ml-2">
                {EXAMPLE_IMAGES.map((_, i) => (
                  <span
                    key={i}
                    className="inline-block rounded-full transition-all duration-300"
                    style={{
                      width: currentSlide === i ? 12 : 6,
                      height: 6,
                      background: currentSlide === i ? '#B5985A' : 'rgba(181,152,90,0.3)',
                    }}
                  />
                ))}
              </span>
            </div>
          </div>

          <div className="mt-4">
            <span className="btn-gold text-sm py-3" data-testid="photo-start-btn">
              Criar Foto
            </span>
          </div>
        </button>
      </section>
    </div>
  );
}
